<template>
    <div class="m-2">
        <BRow>
            <!-- Per Page -->
            <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <label>{{ $t('Show') }}</label>
                <VueSelect v-model="vsPerPage" :options="vsPerPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
                <label>{{$t('entries')}}</label>
            </BCol>

            <!-- Search -->
            <BCol cols="12" md="6">
                <div class="d-flex align-items-center justify-content-between">
                    <!-- <BFormInput v-model="vsSearchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
                    <TextInputValidated :vsModel.sync="vsSearchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                    <BButton variant="primary" :to="{ name: vsRoute }" v-if="ability.can('create', vsModule)">
                        <span class="text-nowrap">{{$t(vsLabel)}}</span>
                    </BButton>
                </div>
            </BCol>
        </BRow>
    </div>
</template>
<script>
import { BButton, BCol, BFormInput, BRow } from 'bootstrap-vue';
import { VueSelect } from 'vue-select';
import ability from '@/libs/acl/ability';
import TextInputValidated from '@/components/forms/TextInputValidated.vue'

export default {
    components: { BRow, BCol, VueSelect, BFormInput, BButton, TextInputValidated },
    props: ['vsPerPage', 'vsPageOptions', 'vsSearchQuery', 'vsPerPageOptions', 'vsRoute', 'vsModule', 'vsLabel'],
    setup(){
        return{
            ability
        }
    }
}
</script>
<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>